export default __webpack_public_path__ + "static/media/icon-home-dark.fcc65b58.svg";